// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__FOQJM","content":"styles_content__1ydjB","checkbox":"styles_checkbox__3FHmd","checkboxLabel":"styles_checkboxLabel__3WJn0"};